import { Component, Inject, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConfig } from '../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { BrowserStorage } from '../../common/utils/tools';
import { SecurityClient } from '../../client/security.client';
import { BaseLoginComponent } from './baseLogin.component';
import { DOCUMENT } from '@angular/common';
import { regExLib } from '../../common/regEx/regExLib';
import { RecaptchaComponent } from 'ng-recaptcha';
import { NotificationClient } from 'src/app/client/notification.client';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  providers: [
    //SecurityService, LocalizationService,
    AppConfig,
    UntypedFormBuilder,
    SecurityClient,
    //, Session, VisualTreeBuilder
  ],
})
export class LoginComponent extends BaseLoginComponent {
  SITE_KEY = '6LfFcCksAAAAAJATFMgjUw5IcTbdde5CMNobUWgR';
  showForgotPassDialog: boolean = false;
  forgotPaswordFinalModel;
  forgotPassFormFinal;
  forgotPassFinalVisible;
  captchaToken;
  captchaValid = false;
  forgotPassForm;
  confirmationDialogVisible;
  confirmationHeader;
  confirmationMessage;
  dialogWidth;

  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;
  constructor(
    public route: ActivatedRoute,
    public config: AppConfig,
    public securityClient: SecurityClient,
    public router: Router,
    public formBuilder: UntypedFormBuilder,

    public translate: TranslateService,
    public renderer: Renderer2,
    @Inject(DOCUMENT) public _document: Document
  ) {
    super(
      route,
      config,
      securityClient,
      router,
      formBuilder,
      translate,
      renderer,
      _document
    );
    BrowserStorage.useFor(this);
    this.form = formBuilder.group({
      user: this.user,
      password: this.password,
    });
  }

  get copyrightInfo() {
    return this.translate.instant(
      'login.copyright',
      {
        year: (new Date()).getFullYear()
      }
    )
  }

  forgotPasswordClick(e) {
    e.preventDefault();
    this.forgotPassFinalVisible = false;
    this.captchaValid = false;
    this.forgotPassForm = this.formBuilder.group({
      emailOrPhone: new UntypedFormControl('', Validators.required),
      username: new UntypedFormControl(''),
    });

    this.forgotPaswordFinalModel = {
      oldPassword: undefined,
      showOld: false,
      newPassword: undefined,
      showNew: false,
      confirmPassword: undefined,
      showConfirm: false,
    };

    this.forgotPassFormFinal = this.formBuilder.group({
      verificationCode: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', this.checkForgotNewPasswords),
      confirmPassword: new UntypedFormControl('', this.checkForgotPasswords),
    });
    this.showForgotPassDialog = true;
  }

  checkForgotPasswords(group: UntypedFormGroup) {
    // here we have the 'passwords' group
    let pass;
    let confirmPass;
    if (group.root.get('newPassword'))
      pass = group.root.get('newPassword').value;
    if (group.root.get('confirmPassword'))
      confirmPass = group.root.get('confirmPassword').value;

    return pass === confirmPass ? null : { notSame: true };
  }

  checkForgotNewPasswords(group: UntypedFormGroup) {
    // here we have the 'passwords' group
    let pass;
    let confirmPass;
    if (group.root.get('newPassword'))
      pass = group.root.get('newPassword').value;
    if (group.root.get('confirmPassword'))
      confirmPass = group.root.get('confirmPassword').value;

    if (!(pass === confirmPass) && group.root.get('confirmPassword'))
      group.root.get('confirmPassword').setErrors({ notSame: true });

    if (group.root.get('newPassword')) {
      let regEx: RegExp = regExLib.regex_ComplexPassword12;
      if (!regEx.test(group.root.get('newPassword').value))
        return { incorrect: true };
    }
    return null;
  }

  forgotPassRequest() {
    this.securityClient
      .sendForgotPasswordInquiry(
        this.translate.instant('forgotPass.sendingInquiry'),
        this.captchaToken,
        this.forgotPassForm.root.get('emailOrPhone').value,
        this.forgotPassForm.root.get('username').value
      )
      .then((result) => {
        this.forgotPassFinalVisible = true;
        this.confirmationHeader = this.translate.instant(
          'forgotPass.confirmationResetRequest'
        );
        this.confirmationMessage = result.result;
        this.confirmationDialogVisible = true;
      }).catch((reason) => {
        this.captchaRef.reset();
        this.captchaValid = false;
      });
  }

  forgotPassRequestFinal() {
    this.securityClient
      .resetPassword(
        this.translate.instant('forgotPass.resettingPassword'),
        this.forgotPassFormFinal.root.get('verificationCode').value,
        this.forgotPassFormFinal.root.get('newPassword').value
      )
      .then((result) => {
        this.forgotPassFinalVisible = false;
        this.showForgotPassDialog = false;
        //confirmation popup
        this.confirmationHeader = this.translate.instant(
          'forgotPass.confirmationResetFinal'
        );
        this.confirmationMessage = this.translate.instant(
          'forgotPass.confirmationMessageResetFinal'
        );
        this.confirmationDialogVisible = true;
      });
  }

  closeConfirmationDialog() {
    this.confirmationDialogVisible = false;
  }

  resolved(event) {
    this.captchaToken = event;
    if (!event) {
      this.captchaValid = false;
    } else {
      //this.captchaValid = false;
      //this.securityClient.captchaVerify(this.translate.instant('forgotPass.verifyingCaptcha'), event).then(resp => {
      this.captchaValid = true;
      //});
    }
  }

}
